<script>
/* global T */
import componentMixin from "../mixins/component-mixin";

export default {
    name: "TdtHeatmap",
    mixins: [componentMixin],
    props: {
        latField: { type: String, default: "lat" },
        lngField: { type: String, default: "lng" },
        valueField: { type: String, default: "count" },
        radius: { type: Number, default: 40 },
        gradient: {
            type: Object,
            default: () => ({
                0.25: "rgb(0,0,255)",
                0.55: "rgb(0,255,0)",
                0.85: "yellow",
                1.0: "rgb(255,0,0)"
            })
        },
        opacity: { type: Number, default: 0.6 },
        data: { type: Array, default: () => [] },
        max: { type: Number },
        visible: { type: Boolean, default: true },
        extData: null
    },
    data() {
        return {
            isReady: false
        };
    },
    watch: {
        data: {
            deep: true,
            handler(val) {
                if(this.isReady && val) {
                    this.setDataSet(val);
                }
            }
        },
        max(val) {
            if(this.isReady && this.data) {
                this.setDataSet(this.data);
            }
        },
        visible(val) {
            if(this.isReady && this.$tdtComponent) {
                this.$tdtComponent.conf.visible = val;
                this.$tdtComponent.conf.container.style.display = val ? "block" : "none";
            }
        },
        radius(val) {
            if(this.isReady && this.$tdtComponent) {
                this.$tdtComponent.setOptions({ radius: val });
            }
        },
        opacity(val) {
            if(this.isReady && this.$tdtComponent) {
                this.$tdtComponent.setOptions({ opacity: val });
            }
        },
        gradient: {
            deep: true,
            handler(val) {
                if(this.isReady && this.$tdtComponent) {
                    this.$tdtComponent.setOptions({ gradient: val });
                }
            }
        }
    },
    methods: {
        initComponent(option) {
            return new Promise(resolve => {
                if(!T.HeatmapOverlay) {
                    return setTimeout(() => {
                        this.initComponent(option);
                    }, 100);
                }
                this.$tdtComponent = new T.HeatmapOverlay(option);
                this.$tdtMap.addOverLay(this.$tdtComponent);
                this.isReady = true;

                if(this.data && this.data.length > 0) {
                    this.setDataSet(this.data);
                }

                resolve(this.$tdtComponent);
            });
        },
        setDataSet(data) {
            if(!this.$tdtComponent || !data) return;

            const maxVal = this.max !== undefined ? this.max : this.getMaxValue(data);
            const heatData = data.map(item => {
                const lng = item[this.lngField];
                const lat = item[this.latField];
                const count = item[this.valueField] || 1;
                return {
                    lng,
                    lat,
                    count
                };
            });

            this.$tdtComponent.setDataSet({
                max: maxVal,
                data: heatData
            });
        },
        getMaxValue(data) {
            if(!data || data.length === 0) return 1;
            let max = 0;
            data.forEach(item => {
                const val = item[this.valueField] || 0;
                if(val > max) max = val;
            });
            return max || 1;
        },
        addDataPoint(lng, lat, count = 1) {
            if(!this.$tdtComponent) return;
            this.$tdtComponent.addDataPoint(lng, lat, count);
        },
        toggle() {
            if(!this.$tdtComponent) return;
            return this.$tdtComponent.toggle();
        },
        setOptions(options) {
            if(!this.$tdtComponent) return;
            this.$tdtComponent.setOptions(options);
        }
    },
    beforeDestroy() {
        if(this.$tdtComponent && this.$tdtMap) {
            this.$tdtMap.removeOverLay(this.$tdtComponent);
        }
    }
};
</script>
